<template>
  <div>
    <el-card shadow="always">
      <el-form
        ref="formInline"
        size="medium"
        label-width="114px"
        :model="formInline"
        inline
      >
        <el-form-item prop="phone" label="学员手机号">
          <el-input
            v-model="formInline.phone"
            style="width: 280px"
            placeholder="请输入学员手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="scopeDate" label="注册时间">
          <my-datePicker
            :scopeDate="formInline.scopeDate"
            @receiveMyDate="receiveMyDate"
          />
        </el-form-item>
        <el-form-item prop="isBindSale" label="是否绑定销售">
          <el-select
            style="width: 280px"
            v-model="formInline.isBindSale"
            placeholder="请选择"
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="saleName" label="跟单销售">
          <el-input
            v-model="formInline.saleName"
            style="width: 280px"
            placeholder="请输入跟单销售"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="companyId" label="所属事业部">
          <el-select
            style="width: 280px"
            v-model="formInline.companyId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in companyData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 30px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset" style="margin-left: 8px"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <br />
      <el-table
        border
        stripe
        v-loading="loading"
        :data="data"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" width="110" align="center">
        </el-table-column>
        <el-table-column label="学员手机号" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.phone || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="微信昵称" minWidth="200" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.nickName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="微信头像" minWidth="200" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.avatar">
              <el-image
                style="width: 60px; height: 60px"
                :src="row.avatar"
                :preview-src-list="[row.avatar]"
              >
              </el-image>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="看课信息" width="150" align="center">
          <template slot-scope="{ row }">
            <span class="blue_Box" @click="openLookClass(row)">查看</span>
          </template>
        </el-table-column>
        <el-table-column label="跟单销售" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.saleName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销售所属主事业部" minWidth="200" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.companyName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="注册时间" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || "--" }}</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>

    <!-- 看课信息 -->
    <LookClass ref="lookClassRef" />
  </div>
</template>

<script>
import {
  getBktClueListByPage,
  getCompanyList,
} from "@/api/videoReference/user.js";
import myDatePicker from "@/components/myDatePicker.vue";
import myPagination from "@/components/myPagination.vue";
import LookClass from "@/views/videoReference/components/lookClass.vue";
import { clone, processing } from "@/utils/handle.js";
export default {
  components: {
    myPagination,
    myDatePicker,
    LookClass,
  },
  data() {
    return {
      loading: false,
      formInline: {
        phone: "",
        scopeDate: [],
        startTime: "",
        endTime: "",
        isBindSale: "",
        saleName: "",
        companyId: "",
      },
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
      companyData: [],
    };
  },
  mounted() {
    this.getCompanyList();
    this.getBktClueListByPage({ page: 1, limit: 10 });
  },
  methods: {
    // 获取租户列表
    async getCompanyList() {
      const res = await getCompanyList({ page: 1, limit: 1000, status: 1 });
      let datas = res.data?.records || [];
      this.companyData = datas.sort((a, b) => {
        if (a.status > b.status) {
          return 1;
        }
        if (a.status < b.status) {
          return -1;
        }
        return 0;
      });
    },
    // 列表请求
    async getBktClueListByPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      delete payload.scopeDate;
      const res = await getBktClueListByPage(payload);
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    receiveMyDate(payload) {
      this.formInline.scopeDate = payload;
      this.formInline.startTime = payload[0] + " 00:00:00";
      this.formInline.endTime = payload[1] + " 23:59:59";
    },
    // 看课信息
    openLookClass(payload) {
      this.$refs.lookClassRef.init(payload);
    },
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getBktClueListByPage(
        Object.assign(processing(this.formInline), {
          page: 1,
          limit: 10,
        })
      );
    },
    handleReset() {
      this.searchData = {};
      this.formInline.scopeDate = [];
      this.formInline.startTime = "";
      this.formInline.endTime = "";
      this.$refs["formInline"].resetFields();
      this.getBktClueListByPage({
        page: 1,
        limit: 10,
      });
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getBktClueListByPage(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getBktClueListByPage(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/index.scss";
</style>